// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QqSquareFilledSvg from "@ant-design/icons-svg/es/asn/QqSquareFilled";
import AntdIcon from '../components/AntdIcon';

var QqSquareFilled = function QqSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: QqSquareFilledSvg
  }));
};

QqSquareFilled.displayName = 'QqSquareFilled';
export default React.forwardRef(QqSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/QqSquareFilled.js
// module id = 1649
// module chunks = 0